import React from "react";

const inputCls = "w-full bg-black border border-[#00ff90]/20 rounded-lg px-3 py-2 text-sm text-white outline-none focus:border-[#00ff90]/50 transition-colors";
const labelCls = "text-xs text-[#00ff90]/50 uppercase tracking-wider block mb-1.5";
const card = "rounded-xl border border-[#00ff90]/30 bg-[#0d0d0d] shadow-[0_0_12px_#00ff9022]";

export default function PerformanceFilters({ filters, setFilters, cycle, setCycle }) {
  const f   = filters || {};
  const set = (k, v) => setFilters?.(prev => ({ ...prev, [k]: v }));

  return (
    <div className={`${card} p-5`}>
      <div className="grid grid-cols-2 md:grid-cols-7 gap-3">
        <div>
          <label className={labelCls}>Cycle ID</label>
          <input className={inputCls} value={f.cycleId || ""} onChange={e => set("cycleId", e.target.value)} />
        </div>
        <div>
          <label className={labelCls}>From</label>
          <input type="date" className={inputCls} value={f.periodFrom || ""} onChange={e => set("periodFrom", e.target.value)} />
        </div>
        <div>
          <label className={labelCls}>To</label>
          <input type="date" className={inputCls} value={f.periodTo || ""} onChange={e => set("periodTo", e.target.value)} />
        </div>
        <div>
          <label className={labelCls}>Location</label>
          <select className={inputCls} value={f.location || "ALL"} onChange={e => set("location", e.target.value)}>
            <option value="ALL">All Locations</option>
            {["London","Bangalore","Remote","New York"].map(l => <option key={l}>{l}</option>)}
          </select>
        </div>
        <div>
          <label className={labelCls}>Department</label>
          <select className={inputCls} value={f.department || "ALL"} onChange={e => set("department", e.target.value)}>
            <option value="ALL">All Departments</option>
            {["Engineering","Product","QA","HR","Ops","Finance"].map(d => <option key={d}>{d}</option>)}
          </select>
        </div>
        <div>
          <label className={labelCls}>Stage</label>
          <select className={inputCls} value={f.stage || "ALL"} onChange={e => set("stage", e.target.value)}>
            <option value="ALL">All Stages</option>
            {["Goal Setting","Self","Mgr Review","Peer","360","Calibration","Finalize"].map(s => <option key={s}>{s}</option>)}
          </select>
        </div>
        <div>
          <label className={labelCls}>Cycle Status</label>
          <select className={inputCls} value={cycle?.status || "OPEN"}
            onChange={e => setCycle?.(prev => ({ ...(prev || {}), status: e.target.value }))}>
            {["OPEN","REVIEW","CALIBRATION","CLOSED"].map(s => <option key={s}>{s}</option>)}
          </select>
        </div>
      </div>
    </div>
  );
}